import React, { Component } from 'react'
import SmoothScroll from 'smooth-scroll'
import t from 'typy'
import classnames from 'classnames'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Header from './Header'
import Footer from './Footer'
// import TermsPopup from 'components/TermsPopup'
import Meta from 'components/MetaHandler'
import GoogleTagManager from 'components/GoogleTagManager'
import Loader from 'components/Loader'
import { templates } from './Templates'
import { env } from 'utils'
import { configure as configureCache } from 'utils/CacheAdaptor'
import './page.css'

class Page extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      loadingContentComponent: false,
      data: false,
      template: '',
      showOffcanvas: false,
      content: false
    }

    this.init = this.init.bind(this)
    this.fetchEndpoint = this.fetchEndpoint.bind(this)
    this.toggleOffcanvas = this.toggleOffcanvas.bind(this)
    this.getContent = this.getContent.bind(this)
  }

  componentDidMount () {
    this.fetchEndpoint(this.props.data.api, this.init)
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (
      (this.state.loading !== nextState.loading) ||
      (this.state.showOffcanvas !== nextState.showOffcanvas) ||
      (this.state.template !== nextState.template) ||
      (this.props.data !== nextProps.data) ||
      (this.state.loadingContentComponent !== nextState.loadingContentComponent)
    ) {
      return true
    }
    return false
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const prevLoc = prevProps.location.pathname
    const newLoc = this.props.location.pathname

    if (prevLoc !== newLoc) {
      this.setState({
        loading: true
      })
      this.fetchEndpoint(this.props.data.api, this.init)
    }
  }

  init (response) {
    this.scrollTop()
    this.setState(
      {
        loading: false,
        data: response.data,
        response: 200,
        template: response.data.template,
        showOffcanvas: false
      },
      () => {
        this.getContent()
        this.enableBodyScroll()
      }
    )
  }

  toggleOffcanvas () {
    this.setState(state => {
      // Lock/unlock body scroll
      if (!state.showOffcanvas) {
        disableBodyScroll(this.header.offcanvas.wrapper)
      } else {
        enableBodyScroll(this.header.offcanvas.wrapper)
      }

      return {
        showOffcanvas: !state.showOffcanvas
      }
    })
  }

  enableBodyScroll () {
    enableBodyScroll(this.header.offcanvas.wrapper)
  }

  fetchEndpoint (endpoint, callback) {
    this.setState({
      loadingContentComponent: true
    })

    if (env !== 'production') {
      console.log('fetching from', endpoint)
    }

    configureCache().then(async (api) => {
      api.get(endpoint)
        .then(async (response) => {
          callback(response)
        })
        .catch((error) => {
          if (error.response) {
            this.setState({
              loading: false,
              data: {
                ...error.response.data,
                template: 'page-404',
                maintenance: true
              },
              response: error.response.status
            })
            console.error('Couldn\'t fetch from', endpoint, 'due to', error)
          } else {
            console.error('Couldn\'t fetch from', endpoint, 'due to', error, '. Is the API down?')
            this.setState({
              loading: false,
              data: {
                template: 'page-404',
                maintenance: true
              },
              response: 500
            })
          }
        })
    })
  }

  scrollTop () {
    const scroll = new SmoothScroll()
    const node = document.getElementById('root')

    scroll.animateScroll(node, false, {
      speed: 0,
      topOnEmptyHash: true,
      updateURL: false,
      popstate: false
    })
  }

  templatePicker = async (template) => {
    return new Promise(function (resolve) {
      let thisTemplate = {
        template: 'Page404'
      }

      if (templates[template] && templates[template] !== '') {
        thisTemplate = t(templates[template]).isObject ? templates[template]
          : {
            template: templates[template]
          }
      }
      import(`${thisTemplate.template}`).then(defaultExport => {
        resolve({
          template: defaultExport
        })
      })
    })
  }

  getContent () {
    const routeTemplate = this.props.data.template // from Route declaration

    const templateName = routeTemplate || this.state.template || this.state.data.template

    this.templatePicker(templateName || 'page-404').then(template => {
      const templatePicked = template
      const DynComponent = templatePicked.template.default

      this.setState({
        loadingContentComponent: false,
        content: (
          <DynComponent
            location={this.props.location}
            history={this.props.history}
            data={this.state.data}
          />
        )
      })
    })
  }

  render () {
    const translation = this.state.data.translation

    if (this.state.loading) {
      return (<Loader
        show={this.state.loading || this.state.loadingContentComponent}
      />)
    }

    return (
      <main className={classnames({
        'page--loading': this.state.loading
      })}>
        <Meta
          meta={this.state.data.metaTags}
        />
        <GoogleTagManager
          gtmId={process.env.REACT_APP_GTM_ID}
        />
        <Header
          loading={this.state.loading}
          translation={translation}
          offcanvas={this.state.showOffcanvas}
          toggleOffcanvas={this.toggleOffcanvas}
          ref={header => { this.header = header }}
        />
        <Loader
          show={this.state.loading || this.state.loadingContentComponent}
        />
        {this.state.content}
        <Footer translation={translation} />
      </main>
    )
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/index.js